import { Component, OnInit } from '@angular/core';
import { Application } from '../../../shared/user.model';
import { UserService } from '../../../shared/user.service';
import { NgForm } from '@angular/forms';
import swal from 'sweetalert2';
import swal1 from 'sweetalert2';
import { Router, ActivatedRoute } from '@angular/router';
import { ErrorHandler } from '../../../shared/ErrorHandler';

@Component({
  selector: 'enactment-form',
  templateUrl: './enactment-form.component.html',
  styleUrls: ['./enactment-form.component.css']
})
export class EnactmentFormComponent implements OnInit {
  title="Add Enactment";
  data : any = {};
  formInvalid : boolean = false;
  e : any = {};

  Enactment_id : number;
  mode : string;

  
  constructor(private UserService: UserService, private router: Router, private route: ActivatedRoute, private errorHandler: ErrorHandler,
    ) 
  { 

  }

  ngOnInit() {
    this.route.params.subscribe(params => {      
      this.Enactment_id = params['Enactment_id'];  
      this.mode =  params['mode'];   
        
        if(this.Enactment_id > 0){
          this.GetEnactmentById(this.Enactment_id)
        }    
    });

    if(this.mode=='view'){
      this.title = "View Enactments ";
    }
    else if(this.mode=='edit'){
      this.title = "Edit Enactments ";
    }  
  }

  SaveEnactments(Enactments: NgForm){ 
    
    if(Enactments.invalid)
    {
      this.formInvalid = true;
      swal('Warning!', 'Please fill all the mandatory fields.', 'warning');
      return;
    }     

    else{                                     
            this.data = this.UserService.PostEnactments(Enactments.value);    
            this.data.subscribe(
            (response) => {
              Enactments.reset();
              Enactments.resetForm();
              Enactments.form.markAsPristine();
              Enactments.form.markAsUntouched();        
              swal('Success!', 'Enactments Added Successfully .', 'success');
              this.router.navigate(['/home/enactments']) ;   
              document.getElementById('loader-spinner').style.display = "none";           
            }, (error) => {
              document.getElementById('loader-spinner').style.display = "none";
              if (error.status == 401|| error.status == 500) {
                this.errorHandler.HandlerError(error);
              }
              else if (error.status == 400) {
                swal('Warning!', error.error.Message, 'warning');
              }
            });    
    
    
    } 
  }

  GetEnactmentById(Enactment_id){
    document.getElementById('loader-spinner').style.display = "block";
        this.data = this.UserService.GetEnactmentById(Enactment_id);
        this.data.subscribe(
          (response: any) => {
            this.e = response;        
                          
            document.getElementById('loader-spinner').style.display = "none";
          }, (error) => {
            document.getElementById('loader-spinner').style.display = "none";
            if (error.status == 401|| error.status == 500) {
              this.errorHandler.HandlerError(error);
            }
            else if (error.status == 400) {
              swal('Warning!', error.error.Message, 'warning');
            }
          });
  }
  UpdateEnactments(Enactments: NgForm) {  
    this.data = this.UserService.UpdateEnactments(Enactments.value,this.Enactment_id);
   this.data.subscribe(
     (response) => {
      Enactments.reset();
      Enactments.resetForm();
      Enactments.form.markAsPristine();
      Enactments.form.markAsUntouched();           
                   
       swal('Success!', 'Enactments updated Successfully .', 'success');
       document.getElementById('loader-spinner').style.display = "none";   
       this.router.navigate(['/home/enactments']) ;          
     }, (error) => {
       document.getElementById('loader-spinner').style.display = "none";
       if (error.status == 401|| error.status == 500) {
         this.errorHandler.HandlerError(error);
       }
       else if (error.status == 400) {
         swal('Warning!', error.error.Message, 'warning');
       }
     });   
}

Cancel(){
//this.router.navigate(['/home/district']) ; 
this.e.Enactment_code='';
this.e.Enactment_name='';
}
}





// WEBPACK FOOTER //
// ./src/app/masters/Enactment/enactment-form/enactment-form.component.ts